import { LanguageRow } from "../../ServerTypes/Administration/LanguageRow";

// TranslationConfig.getLanguageList must stay synchronous (its declared type is `() => LanguageList`,
// no Promise support), so this can't move to LanguageRow.getLookupAsync() - the deprecated sync
// getLookup() staying here is a deliberate exception, not an oversight.
export function getLanguageList() {
    return LanguageRow.getLookup().items
        .filter(x => x.LanguageId != "en")
        .map(k => ({ id: k.LanguageId, text: k.LanguageName }));
}